import awake from "../audio/awake.mp3";
import img from "../img/01.jpg";
import Tomusic from "./Tomusic";
import { MdPlayArrow, MdPause } from "react-icons/md";
import { BsChatSquare } from "react-icons/bs";
import { useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";
import Beatscont from "./Beatscont";
import firebase from "firebase";
import "firebase/storage";
import "firebase/firestore";

const Home = () => {
  const storage = firebase.storage();
  const firestore = firebase.firestore();
  const phone = localStorage.getItem("user-phone");
  const [ids, setIds] = useState([]);
  const [audios, setAudios] = useState([]);
  const [startPageToken, setStartPageToken] = useState(false);
  const styling = {
    color: "black",
    fontSize: "18px",
  };

  useEffect((e) => {
    if (phone !== null) {
      function checkUserInFireStore() {
        const ref = firestore.doc(`users/${phone}`);
        ref.get().then((snap) => {
          if (snap.data().phone === null) {
            localStorage.clear();
          }
        });
      }

      function getAllAudio() {
        const allAudios = firestore
          .collection(`users/${phone}/bucket`)
          .orderBy("createdAt", "desc");
        const array = [];

        allAudios.get().then((docs) => {
          docs.forEach((snap) => {
            const data = snap.data();
            const audiosToSHow = {
              dp: data.dp,
              id: snap.id,
              likes: data.likes,
              audioName: data.audioName,
              name: data.name,
              phone: data.phone,
              src: data.src,
              createdAt: data.createdAt,
            };
            array.push(audiosToSHow);
            setAudios([...audios, ...array]);
          });
        });
      }

      function getDps() {
        const listRef = storage.ref(`users`);
        listRef.list({ maxResults: 1000 }).then((ref) => {
          const prefixes = ref.prefixes;

          prefixes.map((a) => {
            const fRef = firestore.doc(`users/${a.name}`);
            const sRef = storage.ref(`${a.fullPath}/dp`);
            sRef.list().then((dp) => {
              const items = dp.items;
              if (items.length === 1) {
                const dpRef = storage.ref(items[0].fullPath);
                dpRef.getDownloadURL().then((src) => {
                  fRef.update({
                    dp: src,
                  });
                });
              }
            });
          });
        });
      }

      checkUserInFireStore();

      getAllAudio();
    } else {
      localStorage.clear();
    }
  }, []);

  return (
    <div id="home" className="page flex-col-start">
      <div className="home-header flex-btw">
        <h2>
          am<span style={{ color: "seagreen" }}>|3eats</span>
        </h2>
        <nav className="flex-end">
          <Link to="/Chatpage">
            {" "}
            <BsChatSquare style={styling} />{" "}
          </Link>
        </nav>
      </div>

      {<Tomusic />}
      <div id="all-beats" className="flex-col-start">
        {audios.map((a) => {
          return (
            <Beatscont
              key={a.src + a.name}
              src={a.src}
              id={a.id}
              dp={a.dp}
              likes={a.likes}
              name={a.name}
              phone={a.phone}
              audioName={a.audioName}
            />
          );
        })}
      </div>
    </div>
  );
};

export default Home;
